import { render, staticRenderFns } from "./AddIdo.vue?vue&type=template&id=c563d2e2&scoped=true&"
import script from "./AddIdo.vue?vue&type=script&lang=js&"
export * from "./AddIdo.vue?vue&type=script&lang=js&"
import style0 from "./AddIdo.vue?vue&type=style&index=0&id=c563d2e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c563d2e2",
  null
  
)

export default component.exports